import "./style.scss";
import * as React from "react";

import Section from "../../../core/Section";
import Button from "../../../core/Button";
import { NavLink, withRouter } from "react-router-dom";
import { Breadcrumb } from "antd";
import StageOneContainer from "../StageOne";
import StageTwoContainer from "../StageTwo";
import ReportReviewContainer from "../ReportReview";

import { MERCHANT_ID_REGEXP } from "../../../common/constants";

class ReportForm extends React.Component<
  ReportFormProps & RouterChildProps,
  any
> {
  constructor() {
    super();
    this.state = { step: 1 };
  }

  gotoStep(step: number): void {
    window.scrollTo(0, 0);
    this.setState({ step: step });
  }

  handleNextPage() {
    this.gotoStep(this.state.step + 1);
  }

  handleBackPage() {
    this.gotoStep(this.state.step - 1);
  }

  handleSave(sendAfter = false) {
    this.props.submit(
      this.props.match.params.merchant_id,
      this.props.report,
      sendAfter
    );
    this.props.history.push(
      MERCHANT_ID_REGEXP.exec(this.props.location.pathname)[0]
    );
  }

  handleCancel() {
    this.props.flushReport();
    this.props.history.push(
      MERCHANT_ID_REGEXP.exec(this.props.location.pathname)[0]
    );
  }

  renderCrumbs() {
    let crumbs = [];

    switch (this.state.step) {
      case 3:
        crumbs.unshift(
          <Breadcrumb.Item key={1}>
            <a className="breadcrumb" onClick={this.gotoStep.bind(this, 3)}>
              Review Report
            </a>
          </Breadcrumb.Item>
        );
      case 2:
        crumbs.unshift(
          <Breadcrumb.Item key={2}>
            <a className="breadcrumb" onClick={this.gotoStep.bind(this, 2)}>
              {this.props.type} Export Settings
            </a>
          </Breadcrumb.Item>
        );
      case 1:
        crumbs.unshift(
          <Breadcrumb.Item key={3}>
            <a className="breadcrumb" onClick={this.gotoStep.bind(this, 1)}>
              {this.props.type} Report
            </a>
          </Breadcrumb.Item>
        );
    }

    return crumbs;
  }

  renderBody() {
    switch (this.state.step) {
      case 1:
        return <StageOneContainer next={this.handleNextPage.bind(this)} />;
      case 2:
        return (
          <StageTwoContainer
            next={this.handleNextPage.bind(this)}
            back={this.handleBackPage.bind(this)}
          />
        );
      case 3:
        return (
          <ReportReviewContainer
            next={this.handleSave.bind(this)}
            back={this.handleBackPage.bind(this)}
          />
        );
    }
  }

  renderCancelButton() {
    return (
      <div className="antd-cancel-button">
        <Button
          onClick={this.handleCancel.bind(this)}
          className="antd-cancel-button ant-btn-secondary"
        >
          Cancel
        </Button>
      </div>
    );
  }

  componentWillMount() {
    this.setState({
      step:
        this.props.location.state && this.props.location.state.step
          ? this.props.location.state.step
          : 1
    });
  }

  render() {
    const breadcrumb_state_classname = (step: number) => {
      return step == this.state.step ? "selected" : "";
    };
    return (
      <div className="report-form">
        <Breadcrumb>{this.renderCrumbs()}</Breadcrumb>
        {this.renderBody()}
        <div>{this.renderCancelButton()}</div>
      </div>
    );
  }
}

export default withRouter(ReportForm as any);



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/ReportForm/component.tsx